import moment from 'moment';
import {isoDateFormat} from './time-utils.js';

const todayIso = moment().clone().startOf('day').format(isoDateFormat)

const tutorial = [
  {
      "id": "task:tutorial.6",
      "data": {
          "name": "Witaj w Organizerze! To jest przykładowa notatka. Kliknij w nią, żeby dowiedzieć się więcej.",
          "hideCheckbox": true,
          "showNotesInPreview": true,
          "foldedByDefault": true,
          "plannedFor": {
              "parentClass": "day",
              "parentKey": todayIso,
              "seq": "a"
          },
      },
  },
  {
      "id": "task:tutorial.7",
      "data": {
          "name": "W organizerze możesz zapisywać notatki, zadania do zrobienia i cele do osiągnięcia.",
          "hideCheckbox": true,
          "subtaskOf": {
              "parentClass": "task",
              "parentKey": "task:tutorial.6",
              "seq": "a"
          },
      },
  },
  {
      "id": "task:tutorial.8",
      "data": {
          "name": "To jest zadanie - może być zrobione albo nie.",
          "subtaskOf": {
              "parentClass": "task",
              "parentKey": "task:tutorial.6",
              "seq": "b"
          },
      },
  },
  {
      "id": "task:tutorial.9",
      "data": {
          "name": "Możesz zmieniać kolejność elementów - spróbuj!",
          "subtaskOf": {
              "parentClass": "task",
              "parentKey": "task:tutorial.6",
              "seq": "c"
          },
      },
  },
  {
      "id": "task:tutorial.10",
      "data": {
          "name": 'To jest notatka - przydatna kiedy chcesz po prostu zapisać informację (która nie może być "zrobiona").',
          "hideCheckbox": true,
          "subtaskOf": {
              "parentClass": "task",
              "parentKey": "task:tutorial.6",
              "seq": "d"
          },
      },
  },
  {
      "id": "task:tutorial.11",
      "data": {
          "name": "Zadania i notatki można zagnieżdżać. Zobacz co jest w środku!",
          "hideCheckbox": true,
          "subtaskOf": {
              "parentClass": "task",
              "parentKey": "task:tutorial.6",
              "seq": "e"
          },
      },
  },
  {
      "id": "task:tutorial.12",
      "data": {
          "name": "to jest podzadanie",
          "subtaskOf": {
              "parentClass": "task",
              "parentKey": "task:tutorial.11",
              "seq": "a"
          },
      },
  },
  {
      "id": "task:tutorial.13",
      "data": {
          "name": "drugie podzadanie",
          "subtaskOf": {
              "parentClass": "task",
              "parentKey": "task:tutorial.11",
              "seq": "b"
          },
      },
  },
  {
      "id": "task:tutorial.14",
      "data": {
          "name": "Śmiało, możesz wykorzystać tę notatkę do eksperymentów :-) Dobrej zabawy!",
          "hideCheckbox": true,
          "subtaskOf": {
              "parentClass": "task",
              "parentKey": "task:tutorial.6",
              "seq": "f"
          },
      },
  },
]

export default async function uploadTutorial(db) {
  try {
    await db.get('settings')
  } catch (err) {
    db.put({
        _id: "settings",
        labels: [],
    })
    for (const elem of tutorial) {
      const item = elem.data
      item._id = elem.id
      db.put(item)
    }
  }
}